

export const TransformaPaginacionSinDecimales = (total,page) => {
  return Math.ceil(total/page);
}
